import React from 'react';
import classnames from 'classnames';
import { truncStr } from "../../utils";

const WizardFormFirstPage = (props) => {
	const { selectedReportType, handleSelectReportType, isExternalUser, reportsDescriptions, translate } = props;
	return (
		<div className="grid-container">
			<div className="grid-item wiz-table-header title" style={{ textAlign: 'left' }}>
				{translate('ReportType')}
			</div>
			<div className="grid-item wiz-table-header sidebar" style={{ textAlign: 'left' }}>
				{translate('Description')}
			</div>
			<div className="grid-item report-list-container">
				<ul style={{ paddingLeft: 0 }}>
					<div style={{ position: 'relative' }}>
						{reportsDescriptions &&
							reportsDescriptions.length > 0 &&
							reportsDescriptions.map((item, index) => {
								if (
									!item.hidden &&
									(!isExternalUser || (isExternalUser && !!item.visibleForExternal))
								) {
									return (
										<li
											key={index}
											className={classnames('list-item list', {
												selected:
													selectedReportType &&
													selectedReportType.reporttemplatename === item.reporttemplatename
											})}
											onClick={(e) => handleSelectReportType(item, index)}
											style={{ zIndex: '100' }}
										>
											<div
												className="report-mug"
												dangerouslySetInnerHTML={{
													__html:
														item.reportvisiblename && truncStr(item.reportvisiblename, 30)
												}}
											/>
											<div className="clearfix" />
										</li>
									);
								} else return null;
							})}
					</div>
				</ul>
			</div>
			<div
				className="grid-item desc-container"
				style={{ height: '500px' }}
				dangerouslySetInnerHTML={{
					__html: selectedReportType && selectedReportType.reportdescription
				}}
			/>
		</div>
	);
};

/* function truncStr(str, n) {
	return str.length > n ? str.substr(0, n - 1) + '&hellip;' : str;
} */

export default WizardFormFirstPage;
